import React, { useEffect, useState } from "react";

const PaymentFailure = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger animations on mount
    setIsVisible(true);
  }, []);

  return (
    <div className="payment-failed-container">
      <div className="background-particles"></div>

      <div className={`failed-card ${isVisible ? "visible" : ""}`}>
        {/* Error Icon */}
        <div className="icon-section">
          <div className="error-icon">
            <svg viewBox="0 0 100 100" className="error-mark">
              <circle className="error-circle" cx="50" cy="50" r="45" />
              <path className="error-cross-1" d="M30,30 L70,70" />
              <path className="error-cross-2" d="M70,30 L30,70" />
            </svg>
          </div>
        </div>

        {/* Error Message */}
        <div className="message-section">
          <h1 className="error-title">Payment Failed</h1>
          <p className="error-subtitle">Your payment could not be processed.</p>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailure;
